import { Text } from "@/elements"

export const Tag: React.FC<{ text: string }> = ({ text }) => {
  return (
    <div className="rounded-[4px] bg-bg-2 px-2 py-1">
      <Text variant="caption">{text}</Text>
    </div>
  )
}
